const config = {
  // Essentials
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  VERSION: import.meta.env.VITE_VERSION,

  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,

  // Analytics
  CLARITY_PROJECT_ID: import.meta.env.VITE_CLARITY_PROJECT_ID,

  // API and display URLs
  OEMBED_URL: import.meta.env.VITE_OEMBED_URL,
  DISPLAY_URL: import.meta.env.VITE_DISPLAY_URL,

  // Additional config values
  RD_GOLDEN_DATA_ID: import.meta.env.VITE_RD_GOLDEN_DATA_ID,
  NFINITE_CATEGORY_TYPE: import.meta.env.VITE_NFINITE_CATEGORY_TYPE,
  CATEGORY_TREE_LINK: import.meta.env.VITE_CATEGORY_TREE_LINK,
}

const configFn = {
  get(path) {
    const value = config[path]
    if (value === undefined) throw new Error(`Invalid get value [${path}] requested in config`)
    return value
  },
}

export default configFn
